/**
 * @fileoverview Module for `src/pages/KlaviyoForm.js`.
 */

import React from 'react';

/**
 * Embeds a hosted Klaviyo form by class hook.
 *
 * @returns {JSX.Element} Klaviyo form container.
 */
function KlaviyoForm() {
  return <div className='klaviyo-form-X77Xqt' />;
}

export default KlaviyoForm;
